import React, { useEffect, useState, useContext } from 'react';
import { observer } from 'mobx-react';
import { Document, Page, pdfjs } from 'react-pdf';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Loader from 'react-simple-loading';

import MasterCardLogo from '../../assets/master-logo.png';
import PayPalLogo from '../../assets/paypal-by-epoch-1.png';
import VisaLogo from '../../assets/visa-logo.png';
import SummerPackStore from '../../store/SummerPackStore';
import CalendarPage from '../CalendarPage/CalendarPage';
import image from '../../assets/summerpack-promo.png';
import { BASE_URL, SEND_TO_PROCESSOR } from '../../constants/apiUrls/apiUrls';
import { UserContext } from '../../context';
import { PROCESSOR_IDS } from '../../constants/processors';
import callApi from '../../utils/callApi';
import LoginModal from '../../components/generalComponents/LoginModal';
import poster from '../../assets/poster.jpg';
import LoginModalStore from '../../store/LoginModalStore';


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function SummerPackPurchase() {
  const user = useContext(UserContext);
  const hasSummerPack = user.features.includes('SUMMER_PACK_2021');
  const [canShow, setCanShow] = useState(false);
  const {
    products,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    purchased,
    videoUrl,
    magazineUrl,
    loading,
  } = SummerPackStore;
  const selectedProduct = products[0];
  const paysafeAvailable =
    selectedProduct &&
    selectedProduct.categories.find((category) => category.type === 'CC');
  const epochAvailable =
    selectedProduct &&
    selectedProduct.categories.find((category) => category.type === 'EW');

  useEffect(() => {
    SummerPackStore.getProduct();
    if (user.authenticated) {
      SummerPackStore.getAssets();
    }
  }, []);

  useEffect(() => {
    if (!hasSummerPack && (purchased === false || !user.authenticated)) {
      setCanShow(false);
      window.location.href = '/';
    } else if (purchased !== undefined) {
      setCanShow(true);
    }
  }, [purchased, hasSummerPack]);

  const handlePaymentMethod = (e) => {
    setSelectedPaymentMethod(e.target.value);
  };

  const closeLoginModal = (user) => {
    LoginModalStore.setShouldShowModal(false);
    if (user) {
      window.location.reload();
    }
  };

  const checkout = () => {
    if (!user.authenticated) {
      LoginModalStore.setShouldShowModal(true);

      return;
    }
    const { selectedPaymentMethod } = SummerPackStore;
    const processorData = {
      originalDomain: BASE_URL || new URL(document.URL).origin,
      paymentType: selectedPaymentMethod,
      returnPath: '/summerpack-purchase',
      email: user.authenticated ? user.user.account.email : '',
      token: user.user.token,
    };
    const url = SEND_TO_PROCESSOR.replace(
      '{username}',
      encodeURIComponent(user.user.username)
    ).
      replace('{processorId}', encodeURIComponent(PROCESSOR_IDS.SEGPAY)).
      replace('{priceId}', encodeURIComponent(selectedProduct.id));

    callApi(
      url,
      'post',
      {},
      JSON.stringify(processorData),
      { 'content-type': 'application/json; charset=utf-8' },
      false,
      false
    ).then((processorRes) => {
      redirectToProcessor(
        processorRes.data.nextStage.url,
        processorRes.data.nextStage.parameters
      );
    });
  };

  const redirectToProcessor = (url, params) => {
    let buildUrl = `${url}?`;
    let parsedKey = '';

    for (const key in params) {
      if (!params.hasOwnProperty(key)) {
        continue;
      }
      parsedKey =
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}&`;
      buildUrl += parsedKey;
    }
    window.location.href = buildUrl;
  };

  if (loading || !canShow) {
    return <Loader color="white" />;
  }

  return (
    <CalendarPage
      image={image}
      noPhoto={purchased}
      title={
        purchased ? '' : 'Available only for a limited time. Get it TODAY!'
      }
    >
      {purchased ? (
        <>
          <h1>Tie Challenge</h1>
          <video
            className="summerpack-video"
            controls={true}
            controlsList="nodownload"
            poster={poster}
            src={videoUrl}
          />
          <h1>Magazine</h1>
          <a href={`${magazineUrl}#toolbar=0`} rel="noopener noreferrer" target="_blank">
            <Document
              className="pdf-container"
              file={magazineUrl}
              onContextMenu={(e) => e.preventDefault()}
            >
              <Page pageNumber={1} />
            </Document>
          </a>
        </>
      ) : (
        <>
          <div className="calendar-products">
            {products.length > 0 && (
              <>
                <h4>
                  Get access to the exclusive Father's Day Tie Challenge TODAY,
                  receive the first Naked News Magazine and get the Digital
                  Naked News Calendar! But that's not all, this pack also
                  includes a surprise just for you!
                </h4>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={selectedProduct.id}
                    onChange={() => {}}
                  >
                    {products.map((el) => (
                      <FormControlLabel
                        key={el.id}
                        className={`form-control ${
                          el.id === selectedProduct.id ? 'form-control-active' : ''
                        }`}
                        control={<Radio />}
                        label={
                          <div className="product-label">
                            <div className="calendar-dimensions">
                              <span className="calendar-dimensions-name summer-pack-name">
                                SUMMER PROMO PACK
                              </span>
                              <span className="calendar-dimensions-sub summer-pack-sub">
                                Only for our bravest Fans!
                              </span>
                            </div>
                            <span className="summer-pack-price">
                              {el.currency.symbol}
                              {el.amount}
                            </span>
                          </div>
                        }
                        value={el.id}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
                <h3>CHOOSE PAYMENT METHOD</h3>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={selectedPaymentMethod}
                    onChange={handlePaymentMethod}
                  >
                    {epochAvailable && (
                      <FormControlLabel
                        className="form-control"
                        control={<Radio />}
                        label={
                          <div className="product-label">
                            <span>PayPal</span>
                            <span>
                              <img alt="visa" src={VisaLogo} />
                              <img alt="paypal" src={PayPalLogo} />
                            </span>
                          </div>
                        }
                        value="EW"
                      />
                    )}
                    {paysafeAvailable && (
                      <FormControlLabel
                        className="form-control"
                        control={<Radio />}
                        label={
                          <div className="product-label">
                            <span className="payment-label">Credit Card</span>
                            <span>
                              <img alt="visa" src={VisaLogo} />
                              <img alt="mastercard" src={MasterCardLogo} />
                            </span>
                          </div>
                        }
                        value="CC"
                      />
                    )}
                  </RadioGroup>
                </FormControl>
                <button className="btn btn-red btn-calendar" onClick={checkout}>
                  Continue
                </button>
              </>
            )}
          </div>
          {!user.authenticated && (
            <LoginModal closeModal={closeLoginModal} show={LoginModalStore.shouldShowModal} />
          )}
        </>
      )}
    </CalendarPage>
  );
}

export default observer(SummerPackPurchase);
